import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Pseudo from 'i18next-pseudo';
import LanguageDetector from "i18next-browser-languagedetector";

import translationDE from './locales/de.json';
import translationEN from './locales/en.json';
import translationLOREM from './locales/lorem-ipsum.json';

const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  },
  loremIpsum: {
    translation: translationLOREM
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(new Pseudo({
    enabled: true,
    wrapped: true,
    letterMultiplier: 1,
    languageToPseudo: 'loremIpsum'
  }))
  .init({
    resources,
    fallbackLng: "en",
    lng: process.env.USE_DEBUG_PSEUDO
      ? 'loremIpsum'
      : 'de', // default
    debug: false,

    interpolation: {
      escapeValue: false, // react does this already
    },

    detection: {
      order: ["querystring", "cookie", "localStorage", "navigator"],
      caches: ["localStorage", "cookie"]
    },

    postProcess: process.env.USE_DEBUG_PSEUDO
      ? ['pseudo']
      : undefined
  });

export default i18n;
